import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 48 48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "currentColor" }, [
      _createElementVNode("path", { d: "M24 38c-11 0-20-4-20-9v10c0 5 9 9 20 9 3 0 2.5-10 0-10z" }),
      _createElementVNode("ellipse", {
        cx: "24",
        cy: "9",
        rx: "20",
        ry: "9"
      }),
      _createElementVNode("path", { d: "M24 23c-11 0-20-4-20-9v10c0 5 9 9 20 9 2.8 0 2.8-10 0-10zM42.7 29.5c0-4-3.2-7.2-7.1-7.2s-7.1 3.2-7.1 7.2v5.3c-2.5 4-1.3 9.3 2.6 11.8C35 49.1 40.3 48 42.8 44c1.8-2.8 1.8-6.4 0-9.2v-5.3zm-7.2 12.1c-1.2 0-2.1-1-2.1-2.1 0-1.2.9-2.1 2.1-2.1 1.2 0 2.1 1 2.1 2.1s-.9 2.1-2.1 2.1zM40 31.3c0 .2-.1.4-.3.5-.2.1-.4.1-.5 0-2.4-1.2-5.1-1.2-7.5 0-.2.1-.4.1-.5 0-.2-.1-.3-.3-.3-.5v-1.7c0-2.5 2-4.5 4.5-4.5s4.5 2 4.5 4.5v1.7z" })
    ], -1)
  ])))
}
export default { render: render }